/** API paths shared by the server and every client. */
export const routes = {
  health: "/healthz",
  csrf: "/api/csrf",
  /** Setup state and the signed-in user, in one call. */
  session: "/api/session",
  /** First-user setup (the only way to create an account). */
  setup: "/api/setup",
  todos: "/api/todos",
  todo: (id: string) => `/api/todos/${id}`,
  restoreTodo: (id: string) => `/api/todos/${id}/restore`,
  settings: "/api/settings",
  notebooks: "/api/notebooks",
  notebook: (id: string) => `/api/notebooks/${id}`,
  restoreNotebook: (id: string) => `/api/notebooks/${id}/restore`,
  notes: "/api/notes",
  note: (id: string) => `/api/notes/${id}`,
  restoreNote: (id: string) => `/api/notes/${id}/restore`,
  searchNotes: "/api/notes/search",
  noteTitles: "/api/notes/titles",
  /** spec11: changes for the Android app's offline copy. */
  notesSync: "/api/notes/sync",
  trash: "/api/trash",
  attachments: "/api/attachments",
  attachment: (id: string) => `/api/attachments/${id}`,
  attachmentUsage: "/api/attachments/usage",
  unusedAttachments: "/api/attachments/unused",
  trashItem: (kind: string, id: string) => `/api/trash/${kind}/${id}`,
  calendarItems: "/api/calendar/items",
  calendarEvents: "/api/calendar/events",
  calendarEvent: (id: string) => `/api/calendar/events/${id}`,
  restoreCalendarEvent: (id: string) => `/api/calendar/events/${id}/restore`,
  calendarFeeds: "/api/calendar/feeds",
  calendarFeed: (id: string) => `/api/calendar/feeds/${id}`,
  restoreCalendarFeed: (id: string) => `/api/calendar/feeds/${id}/restore`,
  refreshCalendarFeed: (id: string) => `/api/calendar/feeds/${id}/refresh`,
  /** spec12: the home dashboard. */
  home: "/api/home",
  homeBoards: "/api/home/boards",
  homeBoard: (id: string) => `/api/home/boards/${id}`,
  restoreHomeBoard: (id: string) => `/api/home/boards/${id}/restore`,
  homeBoardOrder: "/api/home/boards/order",
  homeWidgets: (boardId: string) => `/api/home/boards/${boardId}/widgets`,
  homeWidget: (id: string) => `/api/home/widgets/${id}`,
  restoreHomeWidget: (id: string) => `/api/home/widgets/${id}/restore`,
  /** spec12 FR11: search the service icon set; POST copies one icon into the attachments. */
  homeIcons: "/api/home/icons",
  homeIcon: (name: string) => `/api/home/icons/${name}`,
  /** spec14: this server's containers and stats (optional, read-only). */
  homeContainers: "/api/home/containers",
  homeContainerStats: "/api/home/containers/stats",
  homeServerStats: "/api/home/server-stats",
  /** spec10 FR7: send a test notification through ntfy. */
  testNotification: "/api/notifications/test",
  /** Better Auth endpoints (mounted at /api/auth/*). */
  auth: {
    signIn: "/api/auth/sign-in/username",
    signOut: "/api/auth/sign-out",
  },
} as const;

/** Header the client sends the CSRF token in for state-changing requests. */
export const CSRF_HEADER = "x-csrf-token";

/**
 * spec08: origin of the Android app's WebView (Capacitor `server.hostname`). The `.invalid`
 * TLD never resolves, so no real site can have it.
 */
export const NATIVE_APP_ORIGIN = "https://app.ronin.invalid";

/** spec08: response header carrying the session token for the native app (Better Auth bearer). */
export const AUTH_TOKEN_HEADER = "set-auth-token";
